import ApiBase from '../ApiBase';

class Groups extends ApiBase {
    route = '/groups';
};

export default new Groups();